export default __webpack_public_path__ + "static/media/menu.ac37755b.svg";